import { render, staticRenderFns } from "./booking_details.vue?vue&type=template&id=589dbe6e&scoped=true&"
import script from "./booking_details.vue?vue&type=script&lang=js&"
export * from "./booking_details.vue?vue&type=script&lang=js&"
import style0 from "./booking_details.vue?vue&type=style&index=0&id=589dbe6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589dbe6e",
  null
  
)

export default component.exports